import { AnyAction, ThunkAction } from '@reduxjs/toolkit';
import { jwtDecode } from 'jwt-decode';
import * as jose from 'jose';
import type { AppTokenModel, AuthState, DecodedToken, DynamicObjectInterface, UserInfo } from '../type';
import { LoggerService } from '../../ui/utils/logger';
import { doLogout } from '../../ui/utils';
import { loginSessionNew, logoutSession } from '../../ui/utils/login';
import authSlide from './authSlice';
import { RootState } from './index';

export const authActions = authSlide.actions;

export const fetchLoginUser = (token: DynamicObjectInterface): ThunkAction<void, RootState, unknown, AnyAction> => {
  return dispatch => {
    if (token) {
      localStorage.setItem('appToken', token.accessToken);
      localStorage.setItem('exp', token.exp);

      let decoded: AppTokenModel = jwtDecode(token.accessToken);
      localStorage.setItem('userId', JSON.stringify(decoded.userId));
      localStorage.setItem('loginId', decoded.loginId);
      localStorage.setItem('pinNumber', String(decoded.pinLevel));

      dispatch(authActions.setLogin({ userInfo: decoded, token: token.accessToken, error: false, errorMessage: '' }));
    } else {
      dispatch(authActions.setLogin({ token: 'INVALID', error: true, errorMessage: '' }));
    }
  };
};

export const clearLogin = (logoutRedirectFn: Function | null): ThunkAction<void, RootState, unknown, AnyAction> => {
  return dispatch => {
    // clear localStorage
    doLogout();
    dispatch(authActions.clearLogin());

    if (!logoutRedirectFn) {
      LoggerService.log('logoutRedirectFn is not defined');
      return;
    }
    logoutRedirectFn();
  };
};

export const fetchLoginSession = ({
  aToken,
  iToken,
  userInfo,
  appToken,
}: {
  aToken: string;
  iToken: string;
  userInfo: UserInfo;
  appToken: string;
}) => {
  return (dispatch: Function) => {
    let aTokenDecoded = jose.decodeJwt(aToken) as DecodedToken;
    let appTokenDecoded = jose.decodeJwt(appToken) as DecodedToken;

    let updatedUserInfo: UserInfo = {
      ...userInfo,
      name: appTokenDecoded?.account?.name ?? userInfo?.name,
      email: appTokenDecoded?.account?.email ?? userInfo?.email,
      id: appTokenDecoded?.account?.id ?? userInfo?.id,
    };

    let authState: AuthState = {
      isLoggedIn: true,
      userInfo: updatedUserInfo,
      token: { access: aToken, id: iToken },
      error: false,
      errorMessage: '',
    };

    loginSessionNew(aTokenDecoded);
    dispatch(authActions.setLogin(authState));
  };
};

export const clearLoginNew = (logoutUrl?: DynamicObjectInterface) => {
  return (dispatch: DynamicObjectInterface) => {
    // clear localStorage
    logoutSession();
    dispatch(authActions.clearLogin());
    if (logoutUrl) {
      window.location.href = logoutUrl;
    }
  };
};
